import { cn } from "@/lib/utils";

interface CardEmptyProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
  title: string;
  description: string;
  variant?: "primary" | "secondary";
}

export const CardEmpty = ({
  children,
  icon,
  title,
  description,
  variant = "primary",
}: CardEmptyProps) => {
  return (
    <div
      className={cn(
        "flex flex-1 items-center justify-center rounded-lg border border-dashed shadow-sm p-10",
        variant === "primary" && "bg-gray-50"
      )}
    >
      <div className="flex flex-col gap-4 items-center max-w-md text-center">
        <div className="flex flex-col items-center gap-2">
          {icon ? (
            <div className="mb-4 p-3 rounded-full bg-primary/10">{icon}</div>
          ) : null}
          <h3 className="text-2xl font-bold">{title}</h3>
        </div>
        <p className="text-muted-foreground">{description}</p>
        {children}
      </div>
    </div>
  );
};
